export default __webpack_public_path__ + "static/media/dokit-logo.27e1ceb7.png";